export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Lisää asiakkaasi',
      description: 'Lähetä asiakkaidesi yhteystiedot meille esimerkiksi CSV-tiedostona. Me hoidamme loput.'
    },
    {
      number: '2',
      title: 'Automaattiset kyselyt',
      description: 'Boostio lähettää asiakkaillesi henkilökohtaisen palautekyselyn sähköpostilla oikeaan aikaan.'
    },
    {
      number: '3',
      title: 'Ohjaus Google-arvosteluun',
      description: 'Tyytyväiset asiakkaat ohjataan suoraan jättämään arvostelu Google-profiiliisi yhdellä klikkauksella.'
    }
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#3B82F6]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#1E3A8A]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16 animate-[fadeInUp_0.8s_ease-out]">
          <div className="inline-block bg-gradient-to-r from-[#3B82F6] to-[#1E3A8A] text-white px-5 py-2 rounded-full text-sm font-semibold mb-4 shadow-lg">
            Yksinkertainen prosessi
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-inter">
            Näin se toimii
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Kolme yksinkertaista vaihetta parempaan näkyvyyteen ja luotettavuuteen
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group">
              <div className="bg-white rounded-2xl md:rounded-[2rem] p-6 md:p-10 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 h-full border border-gray-100 hover:border-[#3B82F6]/30 animate-[fadeInUp_0.8s_ease-out] backdrop-blur-sm" style={{ animationDelay: `${idx * 0.2}s` }}>
                <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-[#3B82F6] to-[#1E3A8A] rounded-2xl flex items-center justify-center text-white text-2xl md:text-3xl font-bold mb-6 md:mb-8 shadow-xl group-hover:scale-110 transition-transform duration-300 group-hover:rotate-3">
                  {step.number}
                </div>
                
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4 group-hover:text-[#1E3A8A] transition-colors duration-300">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed text-base md:text-lg">
                  {step.description}
                </p>
              </div>
              
              {idx < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-4xl text-[#3B82F6] animate-[slideRight_1.5s_ease-in-out_infinite]"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideRight {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(8px);
          }
        }
      `}</style>
    </section>
  );
}